<template>
  <v-app id="inspire" >
    <router-view />
  </v-app>
</template>

<script>
export default {
  props: {
    source: String
  },
  components: {
  },
  data: () => ({
    drawer: null
  }),
  created () {
    // this.$vuetify.theme.dark = true
  }
}
</script>

<style scoped>
  .middle{
    vertical-align:middle
  }
</style>
